import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

/**
 * Email verification is code-based and happens entirely inside the iOS app
 * (the user types a 4-digit code we email them). There's no verification
 * link anymore. This page only exists as a graceful landing spot in case
 * someone opens an old link — it just points them back to the app.
 */
function Verify() {
  return (
    <>
      <div className="legal-header">
        <div className="legal-header-inner">
          <Link to="/" style={{ fontWeight: 800, fontSize: 20, color: 'var(--primary)' }}>Gardeno</Link>
          <Link to="/" style={{ fontWeight: 600, fontSize: 14, color: 'var(--primary)' }}>Back to Home</Link>
        </div>
      </div>
      <div className="legal-content" style={{ textAlign: 'center', maxWidth: 480 }}>
        <h1 style={{ marginBottom: 12 }}>Verify in the app</h1>
        <p className="updated" style={{ marginBottom: 24, color: 'var(--text-secondary)' }}>
          Open the Gardeno app and enter the 4-digit code we emailed you to confirm your address.
          If your code has expired, tap “Resend code” on the verification screen.
        </p>
        <p style={{ fontSize: 14, color: 'var(--text-secondary)' }}>
          Don't have the app yet?{' '}
          <a href="https://apps.apple.com/app/id6767298062" style={{ color: 'var(--primary)', fontWeight: 700 }}>
            Download Gardeno
          </a>
        </p>
      </div>
      <div className="legal-footer">© Gardeno · USTACK GLOBAL (SMC-PRIVATE) LIMITED</div>
    </>
  );
}

export default Verify;
